// removed by extract-text-webpack-plugin
module.exports = {"icon":"_3NVqT","image":"_288IN","heading":"_1xVHU","itemContainer":"_2sbcS","itemInfoMain":"_1UlHz","itemInfoSecondary":"_3Yazz","children":"_1x4sv"};


//////////////////
// WEBPACK FOOTER
// ./components/OrderSummaryItemLarge/styles.scss
// module id = 692
// module chunks = 0